<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="claimId">
    <th mat-header-cell *matHeaderCellDef> Kenmerk </th>
    <td mat-cell ngClass="clickable" *matCellDef="let data" (click)="openPopUp(data)"> {{data.claimId}} </td>
    <td mat-footer-cell *matFooterCellDef> Totaal </td>
  </ng-container>

  <ng-container matColumnDef="premiumPeriod">
    <th mat-header-cell *matHeaderCellDef> Premietijdvak </th>
    <td mat-cell *matCellDef="let data"> {{data.premiumPeriod ? data.premiumPeriod : emptyValuePlaceholder}} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="directDebitType">
    <th mat-header-cell *matHeaderCellDef> Incassowijze </th>
    <td mat-cell *matCellDef="let data"> {{data.directDebitType ? data.directDebitType : emptyValuePlaceholder}} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="reminderPhaseDescription">
    <th mat-header-cell *matHeaderCellDef> Aanmaanfase </th>
    <td mat-cell *matCellDef="let data"> {{data.reminderPhaseDescription ? data.reminderPhaseDescription : emptyValuePlaceholder}} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="lastReminderDate">
    <th mat-header-cell *matHeaderCellDef> Datum aanmaanfase </th>
    <td mat-cell *matCellDef="let data"> {{data.lastReminderDate ? data.lastReminderDate : emptyValuePlaceholder}} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="desiredClaimDate">
    <th mat-header-cell *matHeaderCellDef> Gewenste vorderingsdatum </th>
    <td mat-cell *matCellDef="let data"> {{data.desiredClaimDate ? data.desiredClaimDate : emptyValuePlaceholder}} </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="originalAmount">
    <th mat-header-cell *matHeaderCellDef> Bedrag vordering </th>
    <td mat-cell [ngClass]="{'red': data.originalAmount < 0}" *matCellDef="let data"> {{getAmount(data.originalAmount, 'EUR')}}</td>
    <td mat-footer-cell [ngClass]="{'red': totalOriginalAmount < 0}" *matFooterCellDef> {{getAmount(totalOriginalAmount, 'EUR')}}</td>
  </ng-container>

  <ng-container matColumnDef="outstandingAmount">
    <th mat-header-cell *matHeaderCellDef> Bedrag openstaand </th>
    <td mat-cell [ngClass]="{'red': data.outstandingAmount < 0}" *matCellDef="let data"> {{getAmount(data.outstandingAmount, 'EUR')}} </td>
    <td mat-footer-cell [ngClass]="{'red': totalOutstandingAmount < 0}" *matFooterCellDef> {{getAmount(totalOutstandingAmount,'EUR')}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
  <tr mat-footer-row *matFooterRowDef="tableColumns"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
  {{errorText}}
  </div>
</ng-template>
